import {
  Apple,
  Facebook,
  Google,
  Linkedin,
} from '@hivebrite/design-system/Icon';

const styles = {
  apple: {
    icon: () => <Apple size={15} />,
    name: 'Apple',
    variant: 'secondary',
    label: __('Sign in with Apple'),
  },
  facebook: {
    icon: () => <Facebook size={18} />,
    name: 'Facebook',
    variant: 'primary',
    label: __('Sign in with Facebook'),
  },
  google: {
    icon: () => <Google size={14} />,
    name: 'Google',
    variant: 'secondary',
    label: __('Sign in with Google'),
  },
  linkedin: {
    icon: () => <Linkedin size={18} />,
    name: 'Linkedin',
    variant: 'primary',
    label: __('Sign in with LinkedIn'),
  },
};

export const getProviderStyle = (providerData) => styles[providerData.provider];
